export default {
      id: "icon-tiktok-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "icons.svg#icon-tiktok",
      toString: function () {
        return this.url;
      }
    }